import { SectionTitle } from "../_shared/section-title";
import { PageShell, Stack } from "../_shared/page-shell";
import { Card } from "../_shared/card";
import { ProgressBar } from "../_shared/progress-bar";
import {
  payments,
  paymentsTotalAmountCents,
  paymentsTotalPaidCents,
} from "../_data/mock";

function formatEuros(cents: number) {
  return (cents / 100).toLocaleString("fr-FR", {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: 2,
  });
}

export function PaymentsPage() {
  const progress = paymentsTotalPaidCents / paymentsTotalAmountCents;
  return (
    <>
      <SectionTitle title="Paiements" />
      <PageShell>
        <Stack>
          <Card title="Solde">
            <p className="text-2xl font-bold text-[var(--text-1)]">
              {formatEuros(paymentsTotalPaidCents)}
              <span className="text-base font-normal text-[var(--text-2)]">
                {" "}
                / {formatEuros(paymentsTotalAmountCents)}
              </span>
            </p>
            <div className="mt-3">
              <ProgressBar progress={progress} />
            </div>
          </Card>

          <Card title="Historique">
            <ul className="divide-y divide-[var(--border-1)]">
              {payments.map((p) => (
                <li
                  key={p.id}
                  className="flex items-center justify-between gap-3 py-3 first:pt-0 last:pb-0"
                >
                  <div className="min-w-0">
                    <p className="truncate text-[14px] font-semibold text-[var(--text-1)]">
                      {p.label}
                    </p>
                    <p className="text-[12px] text-[var(--text-2)]">{p.date}</p>
                  </div>
                  <div className="text-right">
                    <p className="text-[14px] font-semibold text-[var(--text-1)]">
                      {formatEuros(p.amountCents)}
                    </p>
                    <p
                      className={`text-[11.5px] font-semibold ${p.paidCents >= p.amountCents ? "text-emerald-600" : "text-orange-600"}`}
                    >
                      {p.paidCents >= p.amountCents ? "Payé" : "À régler"}
                    </p>
                  </div>
                </li>
              ))}
            </ul>
          </Card>
        </Stack>
      </PageShell>
    </>
  );
}
